import { render, staticRenderFns } from "./TransportHisotry.vue?vue&type=template&id=429be3b8&scoped=true&"
import script from "./TransportHisotry.vue?vue&type=script&lang=js&"
export * from "./TransportHisotry.vue?vue&type=script&lang=js&"
import style0 from "./TransportHisotry.vue?vue&type=style&index=0&id=429be3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429be3b8",
  null
  
)

export default component.exports